import { FunctionComponent, useEffect, useRef, useState } from "react";
import './skill.scss'
import DescriptionWrapper from "../Description/DescriptionWrapper";
import Stars from "../Stars/Stars";
import { playHover } from "../../Sounds/Sounds";

export type skill = {
    id: string,
    name: string,
    color: string,
    extraColor?: string,
    type: string,
    stars: number
    known: string[],
    summary: string,
}

type skillProps = {
    skill: skill,
    id: number,
    show: boolean,
    random: number,
    tooltip: string,
}

const Skill: FunctionComponent<skillProps> = ({skill,id,show,random,tooltip}) =>{

    const mainColor = skill.extraColor ? skill.extraColor : skill.color;

    const fontColor = (parseInt(mainColor.substring(1, 3), 16) * 0.229 +  parseInt(mainColor.substring(3, 5), 16) * 0.587 +  parseInt(mainColor.substring(5, 7), 16) * 0.114) > 128 ? "#000000" : "#ffffff";

    const headerRef = useRef<HTMLDivElement | null>(null);
    const descriptionRef = useRef<HTMLDivElement | null>(null);
    const [width, setWidth] = useState("auto");
    const [wasHovered, setWasHovered] = useState(false);
    const [size, setSize] = useState({width: 0, height: 0});

    const tooltipStyle = {
        color: "var(--white)",
    };

    useEffect(() => {
        CheckSize();
        if (headerRef.current) {
            setWidth(`${headerRef.current.offsetWidth}px`);
        }
    },[skill.summary]);


    const CheckSize = () =>{
        if(descriptionRef.current){
            setSize({width: descriptionRef.current.offsetWidth + 16,height: descriptionRef.current.offsetHeight + 16})
        }
    }

    useEffect(() =>{
        for(let i = 0; i < 10; i++){
            setTimeout(() =>{
                CheckSize()
            },100)
        }
    },[])

    const description = (
        <div className='skill-description' ref={descriptionRef}>
            <div className="skill-header" ref={headerRef}>
                <div className="skill-name">{skill.name}</div>
                <Stars defaultValue={skill.stars}/>
            </div>
            <div className="skill-type">{skill.type}</div>
            <div className={`skill-i-know`} style={{color: fontColor, width: width}}>
                {skill.known.map((thing, key) =>(
                    <p key={key}>{thing}</p>
                ))}
            </div>
            <div className="skill-time" style={{width: width}}>{skill.summary}</div>
        </div>
    );

    return(
        <DescriptionWrapper description={description} type="comment" color={mainColor} size={size}>
            <div className={`skill skill-${id} skill-${id}-${show} skill-${show}`} style={{backgroundColor: skill.color, zIndex: `${random === id ? "10" : "2"}`}} onMouseMove={() =>{!wasHovered && setWasHovered(true)}}>
                {
                    (!wasHovered && random === id) && <div className="tooltip" style={tooltipStyle}>{tooltip}</div>
                }
                <div className="image" onMouseEnter={() => {playHover()}}>
                    <img src={`${process.env.PUBLIC_URL}/images/logos/${skill.id}.webp`} alt={skill.name} loading="lazy" fetchPriority="low"/>
                </div>
            </div>
        </DescriptionWrapper>
    )
}

export default Skill